"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dsIcons = require("@olxbr/ds-icons");
var _TipBox = _interopRequireDefault(require("../TipBox"));
var _atoms = require("../../atoms");
var _isSsr = require("../../../helpers/isSsr");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var appUpdateTip = function appUpdateTip() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TipBox["default"], {
    tip: {
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.XCircle, {}),
      text: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_atoms.Text, {
        children: ["Conte\xFAdo ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_atoms.Text, {
          bold: true,
          children: "indispon\xEDvel."
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_atoms.Text, {
        children: " Para visualizar, atualize a p\xE1gina."
      })],
      links: {
        web: (0, _isSsr.isSsr)() ? null : window.location.href
      },
      cta: 'Atualizar'
    },
    variant: "error"
  });
};
var _default = exports["default"] = appUpdateTip;